import type { UseFormReturn } from "react-hook-form";
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
  TextInput,
} from "@/components/ui";
import type { RepairIntakeFormData } from "@/store/useRepairIntakeStore";

type RepairIntakeSection4Props = {
  form: UseFormReturn<RepairIntakeFormData>;
};

export function RepairIntakeSection4({ form }: RepairIntakeSection4Props) {
  return (
    <>
      <FormField
        control={form.control}
        name="section4.serviceFluid"
        render={({ field }) => (
          <FormItem>
            <FormLabel>1. What is the Service/Fluid *</FormLabel>
            <FormControl>
              <TextInput placeholder="Waste Water, Ethylene, Crude Oil" {...field} />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />

      <FormField
        control={form.control}
        name="section4.sdsAttached"
        render={({ field }) => (
          <FormItem>
            <FormLabel>2. Is the SDS Attached? *</FormLabel>
            <Select onValueChange={field.onChange} value={field.value}>
              <FormControl>
                <SelectTrigger>
                  <SelectValue placeholder="Select an option" />
                </SelectTrigger>
              </FormControl>
              <SelectContent>
                <SelectItem value="Yes">Yes</SelectItem>
                <SelectItem value="No">No</SelectItem>
              </SelectContent>
            </Select>
            <FormMessage />
          </FormItem>
        )}
      />
    </>
  );
}
